import * as React from 'react';
import type {
  Trip,
  UpdateTripPayload as Payload,
} from 'contracts/tracking-v2/trips';
import { api, handleApiError } from 'services/api';

export const useUpdateTrip = () => {
  const updateTrip = React.useCallback(async (payload: Payload) => {
    const { tripId, ...tripData } = payload;
    try {
      const url = `/tracking-v2/trips/${tripId}`;
      const { data } = await api.put<Trip>(url, tripData);
      return data;
    } catch (e) {
      throw handleApiError(e);
    }
  }, []);

  return {
    updateTrip,
  }
};
